<template>
  <div>
    <!--规格类别-->
    <Type></Type>

  </div>
</template>

<script>
import Type from './many/Type.vue';
export default {
  components: {
    /*规格类别属性*/
    Type,
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/priceStage/Stage.vue